import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as Parse from 'parse';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services';

@Component({
    selector: 'app-vesta-avatar',
    templateUrl: './vesta-avatar.component.html',
    styleUrls: ['./vesta-avatar.component.scss']
})
export class VestaAvatarComponent implements OnInit, OnDestroy {
    @Input() size?: string;
    @Input() img?: string | null;
    @Input() letters?: string;
    @Input() user?: Parse.User;
    @Input() customerEmail?: string | null;

    private currentUserChangedSubsciption$: Subscription | undefined;

    constructor(private auth: AuthService) {
        this.renderAvatarContent = this.renderAvatarContent.bind(this);
    }

    ngOnInit() {
        this.renderAvatarContent();

        this.currentUserChangedSubsciption$ = this.auth.currentUserChanged.subscribe(this.renderAvatarContent);
    }

    ngOnDestroy() {
        this.currentUserChangedSubsciption$?.unsubscribe();
    }

    renderAvatarContent() {
        // If a user is passed extract img and letters from user
        // Render only if user contains basic info, using .id as test that this is not an empty user
        if (this.user && this.user.id) {
            this.img = this.user.has('avatar') ? this.user.get('avatar').url() : null;

            if (this.user.get('firstname')) {
                this.letters = this.user.get('firstname')[0] + this.user.get('lastname')[0];
            } else {
                this.letters = this.user.getUsername()?.slice(0, 2);
            }
        } else if (this.customerEmail && this.customerEmail.length > 0) {
            this.letters = this.customerEmail.slice(0, 2);
        }
    }
}
